import useLayoutSize, { LayoutSize } from './utils/useLayoutSize';

const useCanDisplayNewPostHistoryView = () => {
  const layoutSize = useLayoutSize();
  return (
    layoutSize && ![LayoutSize.mobile, LayoutSize.tablet].includes(layoutSize)
  );
};

export default useCanDisplayNewPostHistoryView;
